import { Maybe } from 'types/UtilityTypes';

function isValidDate(value: Maybe<Date> | undefined): boolean {
  return value instanceof Date && !Number.isNaN(value.getTime());
}

/** True when default/suggested values include at least one quote date to show in the sidebar. */
export function shouldShowQuickQuoteDateFields(values: {
  pickupDate?: Maybe<Date>;
  deliveryDate?: Maybe<Date>;
  pickupCloseDate?: Maybe<Date>;
  deliveryCloseDate?: Maybe<Date>;
}): boolean {
  return (
    isValidDate(values.pickupDate) ||
    isValidDate(values.deliveryDate) ||
    isValidDate(values.pickupCloseDate) ||
    isValidDate(values.deliveryCloseDate)
  );
}
